import { services } from "@/services/registry";
export function useServices() {
    return services;
}
export default useServices;
